// AdsSearch.jsx
import React, { useState, useEffect } from "react";
import s from "./ads_styles/AdsSearch.module.css";
import AdsPagination from "./AdsPagination";
import AdsMassActions from "./AdsMassActions";
import AdsTableList from "./AdsTableList";

// Список доступных полей сортировки (должны совпадать с backend)
const sortOptions = [
  { value: "fiveads_id", label: "fiveads ID" },
  { value: "ad_id", label: "ID загрузки" },
  { value: "avito_id", label: "Avito ID" },
  { value: "active", label: "Статус" },
  { value: "category", label: "Категория" },
  { value: "title", label: "Заголовок" },
  { value: "last_updated", label: "Обновлено" },
];

export default function AdsSearch({
  projectId,
  endpoint = "/api/ads/get_ads", // при необходимости поменяй на "/api/ads/get_ads"
}) {
  const [query, setQuery] = useState("");
  const [ads, setAds] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("ad_id");
  const [sortOrder, setSortOrder] = useState("asc");
  const [onlyActive, setOnlyActive] = useState(""); // "" или "1"
  const [rangeText, setRangeText] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [selectedAds, setSelectedAds] = useState([]);

  const fetchAds = async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          project_id: projectId,
          query,
          page,
          page_size: pageSize,
          sort_by: sortBy,
          sort_order: sortOrder,
          only_active: onlyActive,
        }),
      });
      const result = await res.json();
      setAds(result.ads || []);
      setRangeText(result.range_text || "");
      const total = Number(result.total || 0);
      setTotalPages(Math.max(1, Math.ceil(total / pageSize)));
    } catch (err) {
      console.error("Ошибка запроса:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, page, sortBy, sortOrder, onlyActive, pageSize]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchAds();
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setPage(1);
  };

  const handleOrderChange = (e) => {
    setSortOrder(e.target.checked ? "desc" : "asc");
    setPage(1);
  };

  const handleOnlyActiveChange = (e) => {
    setOnlyActive(e.target.checked ? "1" : "");
    setPage(1);
  };

  return (
    <div className={s.wrapper}>
      <form onSubmit={handleSearch} className={s.searchBar}>
        <input
          type="text"
          value={query || ""}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Поиск по объявлениям (ID, Ad ID, Avito ID, Title/Description)"
        />
        <button type="submit">Поиск</button>

        <div className={s.sortControls}>
          <label>
            Сортировать по:{" "}
            <select value={sortBy} onChange={handleSortChange}>
              {sortOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </label>

          <label style={{ marginLeft: 10 }}>
            На странице:{" "}
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
              }}
            >
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
              <option value={500}>1000</option>
            </select>
          </label>

          <label style={{ marginLeft: 10 }}>
            <input
              type="checkbox"
              checked={sortOrder === "desc"}
              onChange={handleOrderChange}
            />{" "}
            Обратный порядок
          </label>

          <label style={{ marginLeft: 10 }}>
            <input
              type="checkbox"
              checked={onlyActive === "1"}
              onChange={handleOnlyActiveChange}
            />{" "}
            Только активные
          </label>
        </div>
      </form>

      <AdsPagination
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        totaltext={rangeText}
      />

      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <>
          <AdsMassActions selectedAds={selectedAds} />
          <AdsTableList
            ads={ads}
            selectedAds={selectedAds}
            setSelectedAds={setSelectedAds}
          />
        </>
      )}

      {/* <AdsPagination
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        totaltext={rangeText}
      /> */}
    </div>
  );
}
